<template lang="pug">
.login.text-center(v-on:keyup.enter='login')
  .box
    .logo
      img(src='../assets/nl-logo.png')

    .input-group
      input.form-control(type='text' placeholder='E-post' v-model='email')
      .input-group-append
        span.input-group-text
          font-awesome-icon(icon='user')

    .input-group.mt-2
      input.form-control(type='password' placeholder='Salasõna' v-model='password')
      .input-group-append
        span.input-group-text
          font-awesome-icon(icon='key')

    .alert.alert-warning.mt-2(v-if='error')
      | Sisselogimine ebaõnnestus. Palun kontrolli e-posti ja salasõna.

    .text-center.mt-2
      b-button(variant='primary' @click='login')
        font-awesome-icon(icon='sign-in-alt').mr-2
        | Logi sisse
</template>

<script>
import { backend } from '../api'

export default {
  name: 'login',

  data() {
    return {
      email: '',
      password: '',
      error: false
    }
  },

  methods: {
    async login() {
      try {
        const res = await backend().post('/api/admin/login', {
          username: this.email,
          password: this.password
        })
        this.error = false
        window.localStorage.setItem('accessToken', res.data.accessToken)
        window.localStorage.setItem('refreshToken', res.data.refreshToken)
        this.$router.push('urls')
      } catch (e) {
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss">
.login {
  .box {
    display: inline-block;
    margin-top: 150px;
    width: 400px;
  }

  .input-group-text {
    width: 2.5em;
  }

  .logo {
    padding: 1em 1em 2em 1em;
    text-align: center;

    img {
      display: inline-block;
    }
  }
}
</style>
